import { useState } from "react";
import { useNavigate } from "react-router";
import { useCookies } from "react-cookie";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "../components/AuthProvider.tsx";
import Authorization from "../models/Authorization.tsx";

interface Props {
  isAdministrator: boolean
}

const Login = ({ isAdministrator }: Props) => {
  const { authorization, SetAuthorization } = useAuth();

  const NewCredentials = () => {
    const credentials = {
      Email: "",
      Password: "",
      IsAdministrator: isAdministrator
    }
    return credentials;
  }

  const navigate = useNavigate();
  const [credentials, SetCredentials] = useState(NewCredentials());
  const [success, SetSuccess] = useState(false);
  const [error, SetError] = useState(false);
  const [reset, SetReset] = useState(false);
  const [email, SetEmail] = useState("");
  const [cookies, SetCookie] = useCookies(["Token"]);

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    if (name === "Reset") {
      SetEmail(value);
    } else {
      SetCredentials((prevState) => ({ ...prevState, [name]: value }));
    }
  }

  const SubmitLogin = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials)
    };

    fetch("/api/login", options)
      .then(response => response.text())
      .then(data => {
        const token: string = data;
        if (token === "") {
          SetError(true);
          return;
        }
        
        SetCookie("Token", token, { path: "/" });

        fetch("/api/business?token=" + token)
          .then(response => response.json())
          .then(data => {
            const business = data;
            var isComplete = business.OperatingName &&
              business.LegalName &&
              business.Address &&
              business.City &&
              business.PostalCode &&
              business.OperatingSectorId &&
              business.BusinessSizeId &&
              business.YearsOfOperationId &&
              business.FirstName &&
              business.LastName &&
              business.Email &&
              business.Telephone &&
              business.IsTermsAndConditions;
            const current: Authorization = {
              Token: token,
              Email: business.Email,
              IsAdministrator: business.IsAdministrator,
              IsComplete: isComplete
            };
            SetAuthorization(current);

            // Redirect administrative users
            if (business.IsAdministrator) {
              navigate("/admin/profiles");
            }
            
            // Redirect conventional users based on profile completeness
            if (!business.IsAdministrator)
            {
              if (!isComplete) {
                navigate("/profile");
              } else {
                navigate("/applications");
              }
            }
          })
      })
      .catch(error => console.error(error));
  }

  const SubmitReset = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    fetch("/api/password?email=" + email)
      .then(response => response.text())
      .then(data => {
          SetSuccess(true);
          SetReset(false);
      })
      .catch(error => console.error(error));
  }

  return (
    <div className="login">
      <Snackbar open={success} onClose={() => SetSuccess(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="success" variant="filled" sx={{ width: "100%", padding: 2 }}>
          An email containing instructions on how to reset your password has been sent.
        </Alert>
      </Snackbar>

      <Snackbar open={error} onClose={() => SetError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Email and password do not match an active account.
        </Alert>
      </Snackbar>

      <header>
        <a href="#main" className="skip">Skip to main content</a>
        <div className="container">
            <div className="logo"><a href="/"><img src="/images/logo-login.jpg" alt="Rural Community Immigration Pilot Logo" /></a></div>
            <h1>RCIP {isAdministrator ? "Admin" : "Employer"} Portal Login</h1>  
        </div>
      </header>
      {reset ?
        <section id="main">
          <div className="container">
            <form onSubmit={SubmitReset}>
              <p>
                <label>Email
                  <input type="text" name="Reset" onChange={OnChange} required />
                </label>
              </p>
              <p className="formButton"><input type="submit" value="Reset Password" /></p>
              <p className="formButton"><a onClick={()=> SetReset(false)}>Return to Sign In</a></p>
            </form>            
          </div>
        </section>:
        <section id="main">
          <div className="container">
            <form onSubmit={SubmitLogin}>
              <p>
                <label>Email
                  <input type="text" name="Email" onChange={OnChange} required />
                </label>
              </p>
              <p>
                <label>Password
                  <input type="password" name="Password" onChange={OnChange} required />
                </label>    
              </p>
              <p className="formButton"><input type="submit" value="Login" /></p>
              <p className="formButton"><a onClick={()=> SetReset(true)}>Forgot Password?</a></p>
            </form>
          </div>
        </section>
      }
    </div>
  );
}

export default Login;